
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7d61151a&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./RealtimeView.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RealtimeView.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7d61151a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RealtimeView.vue"),
  /* scopeId */
  "data-v-7d61151a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/views/RealtimeView.vue
// module id = ./dev/src/views/RealtimeView.vue
// module chunks = 0